$(function () {
  // 初期表示処理（紹介コード表示欄の制御と現在、顧問契約を締結している事務所の活性・非活性
  $(document).ready(function () {
    // campaign_codeが空でない場合は登録済みと見なして、紹介コードに関する欄を表示する
    if ($("#campaign_code").get(0).value != "") {
      $(".inquiry").show();
    }
    // 現在、顧問契約を締結している事務所が「あり」の場合は活性化
    if ($('input[name="campaign_code[contract_office]"]:checked').get(0).value == "exist") {
      $("#campaign_code_contract_office_name").prop("disabled", false);
    }
  });

  // 現在、顧問契約を締結している会計事務所名の活性・非活性制御
  $("#campaign_code_contract_office_no_exist").on("click", function () {
    $("#campaign_code_contract_office_name").get(0).value = "";
    $("#campaign_code_contract_office_name").prop("disabled", true);
  });
  $("#campaign_code_contract_office_exist").on("click", function () {
    $("#campaign_code_contract_office_name").prop("disabled", false);
  });

  // 紹介コードをクリップボードにコピーする
  $("#campaign_code").on("click", function () {
    $("#campaign_code").select();
    document.execCommand("copy");
    alert("紹介コードをクリップボードにコピーしました。");
  });
  $("#campaign_code_button").on("click", function () {
    $("#campaign_code").select();
    document.execCommand("copy");
    alert("紹介コードをクリップボードにコピーしました。");
  });

  // 二重送信抑止用
  var isExecuting = false;

  // ajaxにて友人紹介キャンペーンの登録・更新を行う
  $("#friend_campaign_code_regist").on("click", function () {
    // 二重送信抑止（送信中の場合は何もせずに戻る）
    if (isExecuting) return;
    // 二重送信抑止（フラグの更新 + ボタンの非活性化）
    isExecuting = true;
    $("#friend_campaign_code_regist").prop("disabled", true);

    // エラーメッセージの初期化
    $("#office_name_err_msg").remove();
    $("#name_err_msg").remove();
    $("#mail_address_err_msg").remove();
    $("#contract_office_name_err_msg").remove();

    // api呼び出し用のパラメータ取得
    // authorization_key = $("#campaign_code_authorization_key").get(0).value;
    // office_name = $("#campaign_code_office_name").get(0).value;
    user_name = $("#campaign_code_name").get(0).value;
    mail_address = $("#campaign_code_mail_address").get(0).value;
    // contract_office = $('input[name="campaign_code[contract_office]"]:checked').get(0).value;
    // contract_office_name = $("#campaign_code_contract_office_name").get(0).value;

    url = "/api/v1/introduce_friend_campaign_regists";

    // ajax実行
    $.ajax({
      url: url,
      type: "POST",
      dataType: "json",
      data: {
        // authorization_key: authorization_key,
        // office_name: office_name,
        name: user_name,
        mail_address: mail_address
        // contract_office: contract_office,
        // contract_office_name: contract_office_name
      }
    }).done(function (json) {
      if (json.code == "SUCCESS") {
        // エラーが発生しなかった場合の処理
        $("#campaign_code").get(0).value = json.campaign_code;
        $("#campaign_code_campaign_code").get(0).value = json.campaign_code;
        $("#line_share_link").attr("href", json.line_share_url);
        if ($("#line_share_qr_code > svg").length != 0) {
          $("#line_share_qr_code > svg").replaceWith(json.line_qr_code);
        }
        if ($("#line_share_qr_code > svg").length == 0) {
          $("#line_share_qr_code").append(json.line_qr_code);
        }
        $("#send_mail_template").get(0).value = json.sample_mail;
        // 正常終了の場合は紹介コードに関する欄の表示切り替えを行う
        $(".inquiry").show();

        // 完了アラートを表示する
        window.alert("紹介コードが発行されました。発行完了メールを併せてご確認ください。");
      } else if (json.messages.message_regist != "") {
        // 登録処理に失敗（紹介コードの重複５回）の場合、アラートを表示する
        window.alert(json.messages.message_regist);
      } else if (json.messages.message_other != "") {
        // ユーザーにて操作不可能なエラーが発生した場合、システムエラー画面へ飛ばす
        window.location.href = json.error_url;
      } else {
        // エラー処理
        // 事業者名
        if (json.messages.message_office_name != "") {
          $("#office_name_input").append(
            '<p class = "error-text" id = "office_name_err_msg">' + json.messages.message_office_name + "</p>"
          );
        }
        // 氏名
        if (json.messages.message_name != "") {
          $("#name_input").append('<p class = "error-text" id = "name_err_msg">' + json.messages.message_name + "</p>");
        }
        // メールアドレス
        if (json.messages.message_mail_address != "") {
          $("#mail_address_input").append(
            '<p class = "error-text" id = "mail_address_err_msg">' + json.messages.message_mail_address + "</p>"
          );
        }
        // 現在、顧問契約を締結している税理士・会計事務所名
        if (json.messages.message_contract_office_name != "") {
          $("#contract_office_name_input").append(
            '<p class = "error-text" id = "contract_office_name_err_msg">' +
              json.messages.message_contract_office_name +
              "</p>"
          );
        }
      }

      // 二重送信抑止（処理終了後のボタンの活性化 + フラグの処理中フラグの解除）
      $("#friend_").prop("disabled", false);
      isExecuting = false;
    });
  });
  // ajaxにて友人紹介キャンペーンの紹介メールを送信を行う
  $("#campaign_code_send").on("click", function () {
    // 二重送信抑止（送信中の場合は何もせずに戻る）
    if (isExecuting) return;
    // 二重送信抑止（フラグの更新 + ボタンの非活性化）
    isExecuting = true;
    $("#campaign_code_send").prop("disabled", true);
    // エラーメッセージの初期化
    $("#send_mail_address1_err_msg").remove();
    $("#send_mail_address2_err_msg").remove();
    $("#send_mail_address3_err_msg").remove();
    $("#send_mail_address4_err_msg").remove();
    $("#send_mail_address5_err_msg").remove();
    $("#message_mail_other_err_msg").remove();

    // api呼び出し用のパラメータ取得
    campaign_code = $("#campaign_code_campaign_code").get(0).value;
    send_mail_address1 = $("#campaign_code_send_mail_address1").get(0).value;
    send_mail_address2 = $("#campaign_code_send_mail_address2").get(0).value;
    send_mail_address3 = $("#campaign_code_send_mail_address3").get(0).value;
    send_mail_address4 = $("#campaign_code_send_mail_address4").get(0).value;
    send_mail_address5 = $("#campaign_code_send_mail_address5").get(0).value;

    url = "/api/v1/send_friend_campaign_codes";

    // ajax実行
    $.ajax({
      url: url,
      type: "POST",
      dataType: "json",
      data: {
        campaign_code: campaign_code,
        send_mail_addresses: [
          send_mail_address1,
          send_mail_address2,
          send_mail_address3,
          send_mail_address4,
          send_mail_address5
        ]
      }
    }).done(function (json) {
      if (json.code != "SUCCESS") {
        // エラー処理
        if (json.messages.message_other != "") {
          // ユーザーにて操作不可能なエラーが発生した場合、システムエラー画面へ飛ばす
          window.location.href = json.error_url;
        }
        if (json.messages.message_mail_address1 != "") {
          $("#send_mail_address1_input").append(
            '<p class = "error-text" id = "send_mail_address1_err_msg">' + json.messages.message_mail_address1 + "</p>"
          );
        }
        if (json.messages.message_mail_address2 != "") {
          $("#send_mail_address2_input").append(
            '<p class = "error-text" id = "send_mail_address2_err_msg">' + json.messages.message_mail_address2 + "</p>"
          );
        }
        if (json.messages.message_mail_address3 != "") {
          $("#send_mail_address3_input").append(
            '<p class = "error-text" id = "send_mail_address3_err_msg">' + json.messages.message_mail_address3 + "</p>"
          );
        }
        if (json.messages.message_mail_address4 != "") {
          $("#send_mail_address4_input").append(
            '<p class = "error-text" id = "send_mail_address4_err_msg">' + json.messages.message_mail_address4 + "</p>"
          );
        }
        if (json.messages.message_mail_address5 != "") {
          $("#send_mail_address5_input").append(
            '<p class = "error-text" id = "send_mail_address5_err_msg">' + json.messages.message_mail_address5 + "</p>"
          );
        }
        if (json.messages.message_mail_other != "") {
          $("#send_mail_address5_input").append(
            '<p class = "error-text" id = "message_mail_other_err_msg">' + json.messages.message_mail_other + "</p>"
          );
        }
        // 二重送信抑止（処理終了後のボタンの活性化 + フラグの処理中フラグの解除）
        $("#campaign_code_send").prop("disabled", false);
        isExecuting = false;
      } else {
        window.alert("紹介先メールアドレス宛に紹介メールを送信しました。");
        // 二重送信抑止（処理終了後のボタンの活性化 + フラグの処理中フラグの解除）
        $("#campaign_code_send").prop("disabled", false);
        isExecuting = false;
      }
    });
  });
});
